// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qYry","textarea":"styles_textarea__2DxEf"};